import React from 'react';

export const AccordionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16" fill="none">
    <g clipPath="url(#clip0_375_539)">
      <path
        d="M0.000245252 1.52593L14.0007 16.0005L15.4761 14.4751L1.47565 0.000560356L0.000245252 1.52593Z"
        fill="currentColor"
      />
      <path
        d="M12.5256 14.4751L14.001 16.0005L28.0015 1.52593L26.5261 0.000560356L12.5256 14.4751Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_375_539">
        <rect width="16" height="28" fill="white" transform="translate(0 16) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
);
